import { render, staticRenderFns } from "./shareCustomer.vue?vue&type=template&id=8bbc7a9c&"
import script from "./shareCustomer.vue?vue&type=script&lang=js&"
export * from "./shareCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8bbc7a9c')) {
      api.createRecord('8bbc7a9c', component.options)
    } else {
      api.reload('8bbc7a9c', component.options)
    }
    module.hot.accept("./shareCustomer.vue?vue&type=template&id=8bbc7a9c&", function () {
      api.rerender('8bbc7a9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Sales/shareCustomer.vue"
export default component.exports